type RouteKey = "home" | "avatar";

const routes: Record<RouteKey, `/${string}`> = {
    home: "/",
    avatar: "/avatar",
} as const;
  
export default routes;